<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="w-100 d-lg-flex align-items-center justify-content-center mb-5">
            <b-img fluid :src="imgLogo" width="200" class="mx-auto d-block" alt="logo mimedicamento" />
          </div>

          <b-card-text class="mb-2">
            Iniciar sesión
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginFormValidate">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider #default="{ errors }" name="Email" vid="email" rules="required|email">
                  <b-form-input id="login-email" v-model="userEmail" :state="errors.length > 0 ? false : null"
                    name="login-email" placeholder="" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                </div>
                <validation-provider #default="{ errors }" name="Contraseña" vid="password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-password" :disabled="newPassword"/>
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group v-if="newPassword">
                <div class="d-flex justify-content-between">
                  <label for="login-password">Nueva contraseña</label>
                </div>
                <validation-provider #default="{ errors }" name="Nueva contraseña" vid="passwordNew" rules="required">
                  <b-input-group class="input-group-merge mb-1" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-newpassword" v-model="passwordNew" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-newpassword" placeholder="Nueva contraseña" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group v-if="newPassword">
                <div class="d-flex justify-content-between">
                  <label for="login-password">Confirmar nueva contraseña</label>
                </div>
                <validation-provider #default="{ errors }" name="Confirmar nueva contraseña" rules="required|confirmed:passwordNew">
                  <b-input-group class="input-group-merge mb-1" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-confirmPasswordNew" v-model="confirmPasswordNew" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-confirmPasswordNew" placeholder="Confirmar nueva contraseña" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox id="remember-me" v-model="rememberMe" name="checkbox-1">
                  Recuérdame
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block>
                Ingresar
              </b-button>
            </b-form>
          </validation-observer>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text"></div>
          </div>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-forgot-password' }">
              ¿Olvidaste tu contraseña?
            </b-link>
          </p>

        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es';
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/logo/indiju_mimedicamento.png'),
      imgLogo: require('@/assets/images/logo/logo.svg'),
      newPassword: false,
      passwordNew: null,
      confirmPasswordNew: null,
      rememberMe: 0,
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created(){
    localize('es', es)
    this.userEmail = localStorage.getItem('email');
    this.password = localStorage.getItem('password');
    this.rememberMe = localStorage.getItem('rememberMe');
  },
  methods: {
    login() {
      this.$refs.loginFormValidate.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
            passwordNew: this.passwordNew
          })
            .then(response => {
              if (response.data.code == 200) {
                this.newPassword = true;
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Cambiar Contraseña',
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: 'Antes de ingresar debes cambiar la contraseña',
                  },
                })
              }
              if(this.rememberMe){
                localStorage.setItem('email', this.userEmail);
                localStorage.setItem('password', this.password);
                localStorage.setItem('rememberMe', this.rememberMe);
              }else{
                localStorage.setItem('email', '');
                localStorage.setItem('password', '');
                localStorage.setItem('rememberMe', this.rememberMe);
              }
              useJwt.setToken(response.data.access_token)
              useJwt.setRefreshToken(response.data.expires_at)
              this.$http.get('auth/user').then((response) => {
                const { userData } = response.data
                localStorage.setItem('userData', JSON.stringify(userData))
                this.$ability.update(userData.ability)
                this.$router.replace(getHomeRouteForLoggedInUser(userData.role[0]))
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: `Bienvenido ${userData.fullName || userData.username}`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `Has iniciado sesión correctamente como ${userData.role}. Ahora puedes empezar a trabajar!`,
                      },
                    })
                  })
              })
            })
            .catch((error) => {
              console.log(error.response.data.message)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
